import { packageCancellationActionTypes } from './Constants';

const initialState = {
	step: 'manage_package_options',
	open: false,
	loading: false,
	stats: [],
	reasons: [],
	other_tools: [],
	selectedTools: [],
	offers: [],
	availableOffers: [],
	reason: null,
	confirmCancellation: false,
	customToolName: '',
	userExpectationReason: '',
	userOtherReason: '',
	confirmationType: null,
	selectedCancelDate: null,
	cancellationOptions: [],
	offerType: '',
};

export default function packageCancellationReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data, type: offerType } = payload || {};
	const { title, description } = data || {};

	switch (type) {
		case packageCancellationActionTypes.GET_PACKAGE_CANCELLATION_DATA_REQUEST:
			return {
				...state,
				loading: true,
			};

		case packageCancellationActionTypes.GET_PACKAGE_CANCELLATION_DATA_SUCCESS:
			return {
				...state,
				loading: false,
				...data,
			};

		case packageCancellationActionTypes.SET_PACKAGE_CANCELLATION_DATA:
			return {
				...state,
				...data,
			};

		case packageCancellationActionTypes.APPLY_OFFER_REQUEST:
			return {
				...state,
				offerType,
				loading: true,
			};

		case packageCancellationActionTypes.APPLY_OFFER_SUCCESS:
			return {
				...state,
				loading: false,
				successConfirmation: {
					title,
					description,
				},
			};

		case packageCancellationActionTypes.RESET_STATE:
			return initialState;

		default:
			return state;
	}
}
